import {
  ValidationRenderer,
  RenderInstruction,
  ValidateResult
} from 'aurelia-validation';

export class BootstrapFormRenderer {
  render(instruction: RenderInstruction) {
    for (let { result, elements } of instruction.unrender) {
      for (let element of elements) {
        this.remove(element, result);
      }
    }

    for (let { result, elements } of instruction.render) {
      for (let element of elements) {
        this.add(element, result);
      }
    }
  }

  private add(element: Element, result: ValidateResult) {
    if (result.valid) {
      return;
    }

	element.classList.add('is-invalid');

	const formGroup = element.closest('.form-group');
    if (!formGroup) {
      return;
    }

    // add the has-warning class to the enclosing form-group div
    formGroup.classList.add('show-validation-message');

    // First remove existing help-block
    var help = formGroup.getElementsByClassName('aurelia-validation-message')[0];
    if (help)
      formGroup.removeChild(help);

    //then add help-block
    const message = document.createElement('P');
    message.className = 'invalid-feedback aurelia-validation-message';

    if (formGroup.getElementsByTagName('label').length === 1) {
      let displayName = formGroup.getElementsByTagName('label')[0].innerHTML;

      message.textContent = result.message.replace(displayName.trim(), '');
      message.id = `validation-message-${result.id}`;
      formGroup.appendChild(message);
    }
  }

  private remove(element: Element, result: ValidateResult) {
    if (result.valid) {
      return;
    }

	  element.classList.remove('is-invalid');

    const formGroup = element.closest('.form-group');
    if (!formGroup) {
      return;
    }

    // remove help-block
    const message = formGroup.querySelector(`#validation-message-${result.id}`);
	  if (message) {
		  formGroup.removeChild(message);
	  }

	  formGroup.classList.remove('show-validation-message');

      // remove the has-warning class from the enclosing form-group div
      if (formGroup.querySelectorAll('.is-invalid').length === 0) {
        //??
      }
    
  }
}
